<template>
  <div class="page">
    <c-source-page
      :table="table"
      :columns="columns"
      :filter="filter"
      :pagination="pagination"
      resource="categories"
      createButtonText="新建分类"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';
import _ from 'lodash';

@Component
export default class Categories extends Vue {

  pagination = {}

  table = {
    data: [],
    'row-key': 'id',
  };

  get filter() {
    return [
      {
        prop: 'name_or_children_name_cont',
        label: '名字',
        form: {
          component: 'input'
        }
      },
      {
        prop: 'parent_id_eq',
        label: '一级分类',
        form: {
          component: 'select',
          props: {
            clearable: true,
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/categories', { params: { level_eq: 'first_level', per_page: 999 } })
              return _.map(data, category => ({ value: category.id, label: category.name }))
            }
          }
        }
      },
      {
        prop: 'id_eq',
        label: '二级分类',
        form: {
          component: 'select',
          props: {
            clearable: true,
            options: this.table.data.map(item => ({ value: item.id, label: item.name }))
          }
        }
      },
      {
        prop: 'children_id_eq',
        label: '三级分类',
        form: {
          component: 'select',
          props: {
            clearable: true,
            options: _.flatten(this.table.data.map(item => item.children || [])).map(item => ({ value: item.id, label: item.name }))
          }
        }
      },
    ]
  }

  get columns() {
    return createColumns({
      handleChooseFirstColorProductSuccess: this.fetchData,
      handleDeleteSuccess: this.fetchData
    })
  }

  async mounted() {
    this.fetchData();
  }

  async fetchData(params = {}) {
    const { data, pagination } = await this.$request.get('/categories', { params: { ...this.$route.query, ...params } });
    this.table.data = data;
    this.pagination = pagination;
  }
}
</script>
